<script lang="ts" setup>
  import { i18n } from '@/plugins/i18n';

  const main = computed(() => [
    {
      name: i18n.global.t('dashboard'),
      icon: 'home',
      to: '/dashboard',
      permissions: ['user:dashboard'],
    },
    {
      name: i18n.global.t('my_profile'),
      icon: 'stacks',
      to: '/my-profile',
      permissions: ['user:my-profile'],
    },
    {
      name: i18n.global.t('all_articles'),
      icon: 'file',
      to: '/articles',
      permissions: ['user:articles:read'],
    },
    {
      name: i18n.global.t('reports'),
      icon: 'exam',
      to: '/rapportages',
      permissions: ['user:reports:read'],
    },
  ]);

  const footerLinks = computed(() => [
    {
      name: i18n.global.t('terms_and_conditions'),
      to: '/terms-conditions',
      permissions: null,
    },
    {
      name: i18n.global.t('support'),
      to: '/support',
      permissions: null,
    },
  ]);
</script>

<template>
  <SidebarLayout
    :mainLinks="main"
    :footerLinks="footerLinks"
  >
    <slot> </slot>
  </SidebarLayout>
</template>
